module.exports = __webpack_public_path__ + "static/img/1_3_1.644d9d6a.jpg";